import { Layout } from './components';
import { ZoomReports } from './ZoomReports';

export const App = () => {
  return (
    <Layout>
      <ZoomReports />
    </Layout>
  );
};
